export default {
      id: "ic-plan-decheteries-usage",
      viewBox: "0 0 40 40",
      url: "../../../plugins/creasit-builder/assets/dist/images/" + "sprite.svg#ic-plan-decheteries-usage",
      toString: function () {
        return this.url;
      }
    }